module.exports = __webpack_public_path__ + "img/personalcard.c32617a9.svg";